module.exports = __webpack_public_path__ + "static/media/noImage.f55f1123.png";